var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4074 0.814035C13.7403 1.13182 13.7526 1.65931 13.4348 1.99223L4.68483 11.1589C4.5299 11.3212 4.31608 11.4142 4.09172 11.4168C3.86736 11.4194 3.65143 11.3314 3.49278 11.1728L0.576109 8.25609C0.250672 7.93065 0.250672 7.40301 0.576109 7.07758C0.901546 6.75214 1.42918 6.75214 1.75462 7.07758L4.06817 9.39112L12.2292 0.841434C12.547 0.508519 13.0745 0.496252 13.4074 0.814035Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.eb3784cfa09d56d672f0055fe9b6189f.svg";
export { ForwardRef as ReactComponent };